
import { useState } from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import { Card, CardContent } from '@/components/ui/card';

const Terms = () => {
  const [isLoaded, setIsLoaded] = useState(true);

  return (
    <div className={`min-h-screen bg-white ${isLoaded ? 'animate-fade-in' : 'opacity-0'}`}>
      <Navbar />
      
      <main className="pt-24 pb-16">
        <div className="page-container max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold text-autocare-blue mb-4">Terms of Service</h1>
            <p className="text-gray-600">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>
          </div>
          
          <Card>
            <CardContent className="pt-6 prose prose-blue max-w-none">
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing and using the AutoCare services, including our website, mobile applications, 
                and in-person services at our locations, you agree to be bound by these Terms of Service.
                If you do not agree to these terms, please do not use our services.
              </p>
              
              <h2>2. Service Description</h2>
              <p>
                AutoCare provides automotive maintenance and repair services, including but not limited to oil changes,
                fluid checks, tire rotations, and general vehicle inspections. We also offer an online appointment booking system,
                product recommendations, and shop location services.
              </p>
              
              <h2>3. User Accounts</h2>
              <p>
                Some features of our service require you to create an account. You are responsible for maintaining the 
                confidentiality of your account information, including your password, and for all activity that occurs under your account.
                You agree to notify us immediately of any unauthorized use of your account.
              </p>
              
              <h2>4. Booking and Cancellation</h2>
              <p>
                When booking a service appointment through our platform, you agree to arrive at the scheduled time.
                If you need to cancel or reschedule, please do so at least 24 hours in advance. Repeated no-shows may result in
                restrictions on future bookings.
              </p>
              
              <h2>5. Payment Terms</h2>
              <p>
                Payment is due upon completion of services. We accept various payment methods as indicated at each location.
                Prices for services are as listed on our website or as quoted by our service representatives, and may vary by location.
              </p>
              
              <h2>6. Warranty and Service Guarantee</h2>
              <p>
                We provide a 90-day warranty on all services performed. This warranty covers defects in workmanship and materials
                provided by AutoCare. It does not cover damage caused by accidents, misuse, or normal wear and tear.
              </p>
              
              <h2>7. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, AutoCare shall not be liable for any indirect, incidental, special,
                consequential, or punitive damages, including without limitation, loss of profits, data, or use,
                incurred by you or any third party, whether in an action in contract or tort.
              </p>
              
              <h2>8. Privacy Policy</h2>
              <p>
                Your use of our services is also governed by our Privacy Policy, which describes how we collect, use, and share information.
              </p>
              
              <h2>9. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms of Service at any time. We will provide notice of significant changes by
                posting the updated terms on our website. Your continued use of our services after such modifications constitutes
                your acceptance of the revised terms.
              </p>
              
              <h2>10. Contact Information</h2>
              <p>
                If you have questions about these Terms of Service, please contact us at info@autocare.ps or call +970 59 123 456.
              </p>
            </CardContent>
          </Card>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Terms;
